<!-- 接口导出Excel组件 -->
<template>
  <el-button :size="size"
             :icon="icon"
             @click="handleDownExcel"
             :loading="loading"
             :circle="circle"><span v-if="!circle && buttonName">{{ buttonName }}</span>
  </el-button>
</template>
<script>
/**
 * @desc 导出
 * @param config {} 必穿配置项
 *-- @param url { String }  查询导出数据请求地址
 *-- @param ColumnData { Array }  表格配置数据
  *------- @param  ColumnData.exportProp  映射到后台的真实字段。因考虑转义问题 前后台可能都有不一样的处理提供方式覆盖 如 prop: "mineCode", ==> exportProp: 'mineCodeName',  
 *-- @param  buttonName { String } 按钮名称
 *-- @param  icon { String } 按钮图标
 *-- @param  size { String } 按钮尺寸
  @param downloadQuery  列表查询的query对象。 必须保证和query同源 且不能改变原有浅拷贝（堆）
 **/
import { postRequset } from "@/basic-common/util/common.js";
export default {
  name: "ExportByRequest",
  props: {
    config: {
      type: Object,
      required: true,
    },
    downloadQuery: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      type: "",
      size: "small",
      icon: "el-icon-download",
      buttonName: "导出Excel",
      ...this.config,
      loading: false,
      columnData_: []
    };
  },
  watch: {
    'config.ColumnData': {
      handler(newData) {
        this.columnData_ = newData
      }
    },
  },
  methods: {
    // 接口导出Excel
    handleDownExcel() {
      this.$confirm_primary("导出").then(() => {
        let tHeader = [];
        let tHeaderLabel = [];
        this.columnData_.map((item) => {
          if (!item.hide) {
            // 处理转义不同的字段
            const itemProp = item.exportProp || item.prop;
            tHeader.push(itemProp);
            tHeaderLabel.push(item.label);
          }
        });
        let params = {
          ...this.downloadQuery,
          ...{
            exportedColumn: tHeader.join(","),
            exportedColumnName: tHeaderLabel.join(","),
          },
        };
        postRequset(this.config.url, params).then(() => {
          this.$message({
            message: "操作成功，请前往下载中心下载",
            type: "success",
            duration: "3500",
          });
          this.$store.commit("Set_Show_Content", true);
          setTimeout(() => {
            this.$store.commit("Set_Show_Content", false);
          }, 4500);
        });
      });
    },
  },
};
</script>
